import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import {
  concatBreadcrumbs,
  createBreadcrumbObject,
  createPaths,
} from "../../../utils";

import {
  coursesBreadcrumbs,
  coursesRoutesObj,
} from "@routes/facultyMember/courseManagement/courses/path";

// Base route constant
const baseRoute = `${coursesRoutesObj.view}/chapter` as const;

// * Route configuration object for courseChapter-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const courseChaptersRoutesObj = {
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:chapterId`,
  edit: `${baseRoute}/edit/:chapterId`,
} as const;

// ! these are breadcrumbs translation not page title
const courseChaptersRouteTranslation: IRouteTranslation<
  typeof courseChaptersRoutesObj
> = {
  create: "addChapter",
  edit: "editChapter",
  view: "viewChapter",
};

// * Extracts the route parameters for the course-chapters route configuration.
export type ICourseChaptersRouteParams = IExtractRouteParamMap<
  typeof courseChaptersRoutesObj
>;

// * Path functions for the course-chapter routes.
export const courseChaptersPath = createPaths<
  typeof courseChaptersRoutesObj,
  ICourseChaptersRouteParams
>(courseChaptersRoutesObj);

// * Breadcrumbs {translation and route} for the media routes
const thisCourseChapterBreadcrumbs = createBreadcrumbObject<
  typeof courseChaptersRoutesObj
>(courseChaptersRoutesObj, courseChaptersRouteTranslation);

export const courseChapterBreadcrumbs = concatBreadcrumbs<
  typeof courseChaptersRoutesObj
>(coursesBreadcrumbs.view, thisCourseChapterBreadcrumbs);
